import { Fit_13Component } from './../pages/msteps/fit_13';

import { LineSvgClassificaComponent } from './../pages/component/linesvg_classifica';
import { MediaBoxComponent } from './../pages/msteps/mediabox';
import { Mj_Badge } from './../pages/mj_badge/mj_badge';
import { ApertaComponent } from './../pages/msteps/aperta';

import { HomePageDue } from './../pages/homedue/homedue';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule, Badge, Tabs } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { HttpModule } from '@angular/http';
import { IonicStorageModule } from '@ionic/storage';

import { MyApp } from './app.component';
import { DragulaModule, DragulaService } from "ng2-dragula/ng2-dragula"
import { Dashboard } from '../pages/dashboard/dashboard';
import { UserLogin } from '../pages/user-login/user-login';
import { UserForgotpassword } from '../pages/user-forgotpassword/user-forgotpassword';
import { UserSignup } from '../pages/user-signup/user-signup';
import { HTTP } from '@ionic-native/http';
import { Mj_Detail } from './../pages/mj_detail/mj_detail';
import { Mq_List } from '../pages/mq_list/mq_list';
import { MSteps } from '../pages/msteps/msteps';
import { Riordina_3Component } from '../pages/msteps/riordina_3';
import { RiordinaNew_3Component } from '../pages/msteps/riordinanew_3';
import { Multipla_1Component } from '../pages/msteps/multipla_1';
import { Corrispondenza_2Component } from '../pages/msteps/corrispondenza_2';
import { Ripeti_5Component } from '../pages/msteps/ripeti_5';
import { CompletaMultipla_6Component } from '../pages/msteps/completamultipla_6';
import { CompletaRicostruisci_7Component } from '../pages/msteps/completaricostruisci_7';
import { Valutazione_8Component } from '../pages/msteps/valutazione_8';
import { RispostaRating_9Component } from '../pages/msteps/rispostarating_9';
import { Dialogo_10Component } from '../pages/msteps/dialogo_10';
import { RispostaSingola_11Component } from '../pages/msteps/rispostasingola_11';


import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { HatComponent } from '../pages/component/hat';
import { LancetsComponent } from '../pages/component/lancets';
import { LineSvgComponent } from '../pages/component/linesvg';
import { UserStarComponent } from '../pages/component/userstar';
import { Confirm } from '../pages/confirm/confirm';
import { Info } from '../pages/info/info';
import { ExpandableComponent } from '../components/expandable/expandable';
import { SimpleEditorComponent } from '../components/simple-editor/simple-editor';
import { Menu } from '../pages/menu/menu';
import { Profilo } from '../pages/profilo/profilo';
import { BadgePage } from '../pages/badge/badge';
import { Impostazioni } from '../pages/impostazioni/impostazioni';
import { Mj_Sfida } from '../pages/mj_sfida/mj_sfida';
import { Mj_Statistiche } from '../pages/mj_statistiche/mj_statistiche';
import { ChangePassword } from '../pages/changepassword/changepassword';
import { Select_Button } from '../pages/select_button/select_button';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer';
import { File } from '@ionic-native/file';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { Global_Statistiche } from '../pages/global_statistiche/global_statistiche';
import { SafeHtmlPipe } from '../pipes/safe-html/safe-html';
import { ClockComponent } from '../pages/component/clock';
import { EthemeProvider } from '../providers/etheme/etheme';
import { GlobalserviceProvider } from '../providers/globalservice/globalservice';
import { DetailBadge } from '../pages/detail_badge/detail_badge';
import { ClassifichePage } from '../pages/classifiche/classifiche';
import { MediaBoxVideoComponent } from '../pages/msteps/mediaboxvideo';
import { HrListCampionatiPage } from '../pages/hr_listcampionati/hr_listcampionati';
import { HrGraphCampionatiPage } from '../pages/hr_graphcampionati/hr_graphcampionati';
import { ChartsModule } from 'ng2-charts';
import { HrProfiloSquadraPage } from '../pages/hr_profilosquadra/hr_profilosquadra';
import { HrProfiloUtentePage } from '../pages/hr_profiloutente/hr_profiloutente';
import { HrTablePage } from '../pages/hr_table/hr_table';
import { HrLogin } from '../pages/hr_login/hr_login';
import { FeedbackGenericoComponent } from '../pages/msteps/feedbackgenerico';
import { Mj_Statistiche_Sfida } from '../pages/mj_statistiche_sfida/mj_statistiche_sfida';
// import { saveAs } from 'file-saver'; 
import { Firebase } from '@ionic-native/firebase';
import { DelayDragDirective } from "./dragula-touch";
import { TermsPage } from '../pages/terms/terms';
import { HrCaricaUtente } from '../pages/hr_caricautente/hr_caricautente';
import 'chart.js';
import 'chart.piecelabel.js';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import {  Http } from '@angular/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ApertaRicostruisci_12Component } from '../pages/msteps/apertaricostruisci_12';
import { RispostaRank_14Component } from '../pages/msteps/rispostarank_14';
import { SelectSquadraPage } from '../pages/select-squadra/select-squadra';

import { ModalfasixPage } from '../pages/modalfasix/modalfasix';
import { MjsospesiPage } from '../pages/mjsospesi/mjsospesi';
import { ErrorPage } from '../pages/error/error';
import { LineSvgPercorsoComponent } from '../pages/component/linesvg_percorso';
import { ConfirmLogout } from '../pages/confirmLogout/confirmLogout';
import { HrListUtentiPage } from '../pages/hr_listutenti/hr_listutenti';
import { CambiaSquadraPage } from '../pages/cambia-squadra/cambia-squadra';
import { HrSelezionaMjPage } from '../pages/hr_selezionamj/hr_selezionamj';
import { HrEmailInvito } from '../pages/hr_emailinvito/hr_emailinvito';

@NgModule({
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  declarations: [
    DelayDragDirective,
    MyApp,
    HomePageDue,
    Dashboard,
    UserLogin,
    UserForgotpassword,
    UserSignup,
    Mj_Detail,
    Mq_List,
    MSteps,
    ApertaComponent,
    Riordina_3Component,
    RiordinaNew_3Component,
    Multipla_1Component,
    Corrispondenza_2Component,
    Ripeti_5Component,
    CompletaMultipla_6Component,
    CompletaRicostruisci_7Component,
    Valutazione_8Component,
    RispostaRating_9Component,
    Dialogo_10Component,
    RispostaSingola_11Component,
    ApertaRicostruisci_12Component,
    Fit_13Component,
    RispostaRank_14Component,
    MediaBoxComponent,
    MediaBoxVideoComponent,
    HatComponent,
    LancetsComponent,
    LineSvgComponent,
    LineSvgClassificaComponent,
    LineSvgPercorsoComponent,
    UserStarComponent,
    Confirm,
    ConfirmLogout,
    Info,
    DetailBadge,
    ExpandableComponent,
    SimpleEditorComponent,
    Menu,
    BadgePage,
    Profilo,
    Impostazioni,
    Mj_Sfida,
    Mj_Statistiche,
    Mj_Badge,
    ChangePassword,
    Select_Button,
    Global_Statistiche,
    SafeHtmlPipe,
    ClockComponent,
    ClassifichePage,
    HrListCampionatiPage,
    HrGraphCampionatiPage,
    HrProfiloSquadraPage,
    HrListUtentiPage,
    HrProfiloUtentePage,
    HrTablePage,
    HrLogin,
    FeedbackGenericoComponent,
    Mj_Statistiche_Sfida,
    TermsPage,
    HrCaricaUtente,
    HrEmailInvito,
    SelectSquadraPage,
    MjsospesiPage,
    ModalfasixPage,
    ErrorPage,
    CambiaSquadraPage,
    HrSelezionaMjPage
  ],
  imports: [
    BrowserModule,
    DragulaModule,
    HttpModule,
    HttpClientModule,
    ChartsModule,
    IonicModule.forRoot(MyApp, {
      mode: 'md'
    },{     
      links: [
        {component: HrLogin, name: 'hr', segment: 'hr'}]
      }),
    IonicStorageModule.forRoot(),
    RoundProgressModule,
    NgCircleProgressModule.forRoot({
      // set defaults here
      radius: 60,
      space: -16,
      toFixed: 0,
      //outerStrokeGradient: true,
      outerStrokeWidth: 16,
      outerStrokeColor: "#4882c2",
      //outerStrokeGradientStopColor: "#53a9ff",
      innerStrokeColor: "#4b4b50",
      innerStrokeWidth: 16,
      title: "UI",
      animateTitle: false,
      animationDuration: 1000,
      showUnits: false,
      showBackground: false,
      clockwise: true,
      startcolor:'#ff9400',
      endcolor: '#d6e000'
      //startFromZero: false,

    }),
    // TranslateModule.forRoot()
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePageDue,
    Dashboard,
    UserLogin,
    UserForgotpassword,
    UserSignup,
    Mj_Detail,
    Mq_List,
    MSteps,
    ApertaComponent,
    Riordina_3Component,
    RiordinaNew_3Component,
    Multipla_1Component,
    Corrispondenza_2Component,
    Ripeti_5Component,
    CompletaMultipla_6Component,
    CompletaRicostruisci_7Component,
    Valutazione_8Component,
    RispostaRating_9Component,
    RispostaRank_14Component,
    Dialogo_10Component,
    RispostaSingola_11Component,
    ApertaRicostruisci_12Component,
    Fit_13Component,
    MediaBoxComponent,
    MediaBoxVideoComponent,
    HatComponent,
    LancetsComponent,
    LineSvgComponent,
    LineSvgClassificaComponent,
    LineSvgPercorsoComponent,
    UserStarComponent,
    Confirm,
    ConfirmLogout,
    Info,
    DetailBadge,
    ExpandableComponent,
    Menu,
    BadgePage,
    Profilo,
    Impostazioni,
    Mj_Sfida,
    Mj_Statistiche,
    Mj_Badge,
    ChangePassword,
    Select_Button,
    Global_Statistiche,
    ClockComponent,
    ClassifichePage,
    HrListCampionatiPage,
    HrGraphCampionatiPage,
    HrProfiloSquadraPage,
    HrProfiloUtentePage,
    HrTablePage,
    HrLogin,
    FeedbackGenericoComponent,
    Mj_Statistiche_Sfida,
    TermsPage,
    HrCaricaUtente,
    HrEmailInvito,
    SelectSquadraPage,
    MjsospesiPage,
    HrListUtentiPage,
    ModalfasixPage,
    ErrorPage,
    CambiaSquadraPage,
    HrSelezionaMjPage
  ],
  providers: [
    HttpClient,
    StatusBar,
    SplashScreen,
    DragulaService,
    HTTP,
    ApertaComponent,
    Riordina_3Component,
    RiordinaNew_3Component,
    Multipla_1Component,
    Corrispondenza_2Component,
    Ripeti_5Component,
    CompletaMultipla_6Component,
    CompletaRicostruisci_7Component,
    Valutazione_8Component,
    RispostaRating_9Component,
    Dialogo_10Component,
    RispostaSingola_11Component,
    ApertaRicostruisci_12Component,
    Fit_13Component,
    RispostaRank_14Component,
    FeedbackGenericoComponent,
    MediaBoxComponent,
    MediaBoxVideoComponent, 
    HatComponent,
    LancetsComponent,
    LineSvgComponent,
    LineSvgClassificaComponent,
    LineSvgPercorsoComponent,
    UserStarComponent,
    ClockComponent,
    FileTransfer,
    FileTransferObject,
    File,
    Camera,
    Firebase,
    // saveAs,
    { provide: ErrorHandler, useClass: IonicErrorHandler }, 
    EthemeProvider,
    GlobalserviceProvider
    
  ]
})
export class AppModule {
  
 }


 export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


// WEBPACK FOOTER //
// ./src/app/app.module.ts